import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SecondaryNav } from '@feathr/components';
import { useNavigation } from '@feathr/extender/state';

import HomeNav from '../PrimaryNav/HomeNav';

interface IHomeSecondaryNavProps {
  className?: string;
}

function HomeSecondaryNav({ className }: Readonly<IHomeSecondaryNavProps>): JSX.Element {
  const { t } = useTranslation();
  const { setActiveSecondaryNav, scrollableRef } = useNavigation();

  const handleBack = (): void => {
    setActiveSecondaryNav(null);
  };

  return (
    <SecondaryNav
      className={className}
      onBack={handleBack}
      scrollableRef={scrollableRef}
      title={t('Home')}
    >
      <HomeNav indented={false} />
    </SecondaryNav>
  );
}

export default HomeSecondaryNav;
